import VerifyAddressValidationModal from './VerifyAddressValidationModal';
export default VerifyAddressValidationModal;